import { ContactApi } from './contactApi';

const contactApi = new ContactApi();

export { contactApi };